import React, { useState } from "react";

const UseStateCounter = () => {
  const [value, setValue] = useState(0);

  const resetNumber = () => {
    setValue((resetValue) => {
      return (resetValue = 0);
    });
  };

  const incrementLater = () => {
    setTimeout(() => {
      setValue((hehe) => {
        return hehe + 1;
      });
    }, 2000);
  };

  const decrementLater = () => {
    setTimeout(() => {
      setValue((hehe) => {
        return hehe - 1;
      });
    }, 2000);
  };

  return (
    <>
      <section style={{ margin: "4rem 0" }}>
        <h2>Regular Counter</h2>
        <h1>{value}</h1>
        <button className="btn" onClick={() => setValue(value - 1)}>
          Decrement
        </button>
        <button className="btn" onClick={resetNumber}>
          Reset
        </button>
        <button className="btn" onClick={() => setValue(value + 1)}>
          Increment
        </button>
      </section>
      <section style={{ margin: "4rem 0" }}>
        <h2>More Complex Counter</h2>
        <h1>{value}</h1>
        <button className="btn" onClick={decrementLater}>
          Decrease Later
        </button>
        <button className="btn" onClick={resetNumber}>
          Reset
        </button>
        <button className="btn" onClick={incrementLater}>
          Increase Later
        </button>
      </section>
    </>
  );
};

export default UseStateCounter;
